import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
// import { PrelanderV16Page } from './ui/pages/PrelanderV16Page';
import { PrelanderV28Page } from './ui/pages/PrelanderV28Page';
import { UpsellSpecialV3Page } from './ui/pages/UpsellSpecialV3Page';
import { UpsellBundlePage } from './ui/pages/UpsellBundlePage';
import { getPurchaseData } from './lib/use-cases/get-purchase';
import { getFbclid } from './lib/shared/ad-helpers';
import { amplitudeTracker } from './lib/shared/amplitude-tracker';
import { setCustomHeightVariable } from './lib/shared/dimensions';
import { sentryLogger } from './lib/shared/sentry-logger';
import { growthBook } from './lib/shared/growthbook';
import config from './config';
import '@virtualstate/navigation/polyfill';
import { initFacebookPixelIfConsented } from './lib/shared/facebook-tracker';
import './common.css';

sentryLogger.init(config.environment);
initFacebookPixelIfConsented();

const PATH_NAMES = ['', '/v28'];

amplitudeTracker.init(config.amplitudeApiKey, config.amplitudeServerUrl);
amplitudeTracker.onSubscribe();
const growthBookInstance = growthBook.init(config.growthBookApiHost, config.growthBookClientKey, config.environment);

growthBook.setUserAttributes();
growthBook.onSubscribe();

function App() {
    useEffect(() => {
        setCustomHeightVariable();
        window.addEventListener('resize', setCustomHeightVariable);
        growthBook.loadFeatures();

        if (PATH_NAMES.includes(window.location.pathname)) {
            const purchaseData = getPurchaseData();

            if (getFbclid(window.location.search) && purchaseData.subscriptionId) {
                window.location.replace(`${config.platformUrl}/dashboard`);
            }
        }
    }, []);

    const renderPage = () => {
        // if (window.location.pathname === '/v16') {
        //     return <PrelanderV16Page initialPrelander='v16.3' />;
        // }

        if (window.location.pathname === '/v28') {
            return <PrelanderV28Page initialPrelander='v28.1' />;
        }

        if (window.location.pathname === '/upsell/bundle') {
            return <UpsellBundlePage />;
        }

        if (window.location.pathname === '/upsell/special/v3') {
            return <UpsellSpecialV3Page />;
        }

        if (window.location.pathname === '/') {
            return <PrelanderV28Page initialPrelander='v28.1' />;
        }

        return window.location.replace('/');
    };

    return (
        <GrowthBookProvider growthbook={growthBookInstance}>
            {renderPage()}
        </GrowthBookProvider>
    );
}

const root = createRoot(document.getElementById('root'));

root.render(<App />);
